import React, { useState, useEffect } from 'react'
import { Button, Typography, CircularProgress, Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { TextFieldFormsy } from '@fuse'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { displayCountLimit } from 'commons/number'

const useStyles = makeStyles((theme) => ({
  root: {
    right: '1%',
    top: '8%',
    cursor: 'pointer',
    zIndex: '10',
    color: theme.palette.button.primary.disable.text,
  },
  maxLengthText: {
    right: '0',
  },
  errorMessage: {
    position: 'absolute',
    bottom: '32%',
    right: '7px',
  },
}))
const useTranslator = (id) => {
  let data = [{ id }]
  if (typeof id === 'object') {
    data = id
  }
  return useIntl().formatMessage(...data)
}
const useInputParams = (props) => {
  const { labelId, placeholderId } = props
  const label = useTranslator(labelId)
  const placeholder = useTranslator(placeholderId)
  return { label, placeholder }
}

export const TextInput = (props) => {
  const {
    labelId,
    placeholderId,
    maxLength,
    isDisplayMaxLengthText = true,
    containerClassName,
    extraOnChangeFunctions,
    clearBtn,
    onTextClear,
    listenDescriptionLength,
    errorMessage,
    getErrorMessage = () => {},
    ...rest
  } = props

  const { label, placeholder } = useInputParams({ labelId, placeholderId })
  const [charCount, setCharCount] = useState(0)
  const [activeClearButton, setActiveClearButton] = useState(false)
  const propsClass = useStyles(props)

  const textErrorMessage = getErrorMessage()
  useEffect(() => {
    if (rest.value) {
      setCharCount(rest.value.length)
    }
  }, [rest.value])
  useEffect(() => {
    if (clearBtn) {
      setActiveClearButton(clearBtn)
    }
  }, [clearBtn])

  function onChange(event) {
    setCharCount(event.currentTarget.value.length)
    props.listenDescriptionLength &&
      props.listenDescriptionLength(event.currentTarget.value.length)
    if (props.onChange) {
      props.onChange(event)
    }
  }

  const resetPlaceField = () => {
    onTextClear()
    setCharCount(0)
  }
  return (
    <div className={clsx('relative', containerClassName)}>
      <Icon
        small="true"
        onClick={resetPlaceField}
        className={
          activeClearButton ? clsx(propsClass.root, 'absolute') : 'hidden'
        }
      >
        cancel
      </Icon>
      <TextFieldFormsy
        onChange={(e) => {
          onChange(e)
          extraOnChangeFunctions && extraOnChangeFunctions(e)
        }}
        label={label}
        placeholder={placeholder}
        type="text"
        margin="normal"
        variant="outlined"
        {...rest}
        inputProps={R.mergeRight(rest.inputProps, {
          maxLength: maxLength,
        })}
        fullWidth
        error={errorMessage}
        helperText={textErrorMessage}
      />
      {R.isNil(maxLength)
        ? null
        : isDisplayMaxLengthText && (
            <Typography
              variant="caption"
              color="textSecondary"
              className={clsx(
                errorMessage
                  ? propsClass.errorMessage
                  : 'absolute bottom-0 right-0 rtl:pb-4 rtl:pl-8 ltr:pb-4 ltr:pr-8',
                propsClass.maxLengthText,
              )}
            >
              {displayCountLimit(charCount, maxLength)}
            </Typography>
          )}
    </div>
  )
}
TextInput.propTypes = {
  labelId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  placeholderId: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  clearBtn: PropTypes.bool,
  onTextClear: PropTypes.func,
}

const useStyle = makeStyles((theme) => ({
  text: {
    color: theme.palette.primary.contrastText,
  },
}))
export const ButtonWithLoading = (props) => {
  const defaultStyle = useStyle()
  const { labelId, isLoading, children, className, CircularProp, ...rest } =
    props
  const getLabel = () =>
    R.isNil(labelId) ? children : <FormattedMessage id={labelId} />
  const isColorNotExist = R.compose(R.isNil, R.prop('color'))
  return (
    <Button
      variant="contained"
      color="secondary"
      className={clsx(defaultStyle.text, className)}
      {...rest}
    >
      {isLoading ? (
        <CircularProgress
          size={24}
          className={
            isColorNotExist(CircularProp) ? clsx(defaultStyle.text) : ''
          }
          {...CircularProp}
        />
      ) : (
        getLabel()
      )}
    </Button>
  )
}
ButtonWithLoading.propTypes = {
  isLoading: PropTypes.bool,
  labelId: PropTypes.string,
}
